import React from 'react'
import PropTypes from 'prop-types'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import TimelineTracking from 'domains/customer-shipment/organisms/timeline-tracking'
import SHIPMENT_METHOD from 'domains/customer-checkout/constants/checkout-shipment-method'
import CourierDetailView from 'domains/customer-shipment/organisms/courier-detail-view/courier-detail-view'

const propTypes = {
  toggle           : PropTypes.func,
  shipment         : PropTypes.object,
  trackingHistory  : PropTypes.object,
  trackingResponse : PropTypes.object
}

const TrackShipmentModal = ({
  shipment,
  trackingHistory,
  trackingResponse,
  ...props
}) => {
  const courierExist           = !!trackingResponse.courier
  const trackingUrl            = trackingResponse.trackingURL
  const showLiveTrackingButton = shipment.courier === SHIPMENT_METHOD.GRAB_EXPRESS && !!trackingUrl

  return (
    <Modal
      centered
      { ...props }
    >
      <ModalHeader toggle={ props.toggle }>
        <span className='mx-2 text-gray'>{ 'Shipment Tracked' }</span>
      </ModalHeader>
      <ModalBody>
        {
          courierExist && (
            <CourierDetailView
              shipment={ shipment }
              trackingResponse={ trackingResponse }
            />
          )
        }
        {
          showLiveTrackingButton && (
            <a
              className='btn btn-primary mb-3'
              href={ trackingResponse?.trackingURL }
              target="_blank"
              rel="noreferrer"
            >
              { 'Live Tracking' }
            </a>
          )
        }
        <TimelineTracking data={ trackingHistory }/>
      </ModalBody>
    </Modal>
  )
}

TrackShipmentModal.propTypes = propTypes

export default TrackShipmentModal